import { useFetch } from '../../../hooks/useFetch';
import { vendorService } from '../services/vendorService';
import type { Vendor } from '../types/vendorTypes';

/** One supplier by id; `id` undefined (new supplier) resolves to null without a request. */
export function useVendor(id?: string) {
  return useFetch<Vendor | null>(() => (id ? vendorService.get(id) : Promise.resolve(null)), [id]);
}
